import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import CardVertical from '../Common/CardVertical/CardVertical';
import Carousel from "../Helpers/Widgets/SwipeCarousel/Carousel";
import { ProductList } from "../Common/data/Products";
import * as _ from "lodash";

export default function Products(props) {
  return <ProductsView
    ishomePage={props.ishomePage || ''}
    productList={ProductList()}
     />
}

function ProductsView(props) {
  const [currentIndex, setCurrentIndex] = useState(parseInt((window.innerWidth - 250) / 197, 10))
  const [showCarouselArrow, setShowCarouselArrow]= useState(false);
  const { productList } = props;
  const cards = productList.map((item, index) =>
      <Col key={index} xs="auto" className="pr-0 pb-3 mt-3">
        <CardVertical
          ishomePage={props.ishomePage || ''}
          detailsLink={`/Products/Landing/${item.key}`}
          name={item.name}
          icon={item.icon}
          productKey={item.key}
          href={item.href}
          sessionKey={item.sessionKey}
        />
      </Col>
  )
  const checkShowCarouselArrow = (count) => {
    const width = window.innerWidth - 250;
    const totalWidthRquired = 197 * count;
    if (totalWidthRquired > width) {
      setShowCarouselArrow(true)
    }
    else{
      setShowCarouselArrow(false);
    }
  }
  const noOfCardDispalyed = () => {
    return parseInt((window.innerWidth - 250) / 197, 10);
  }
  const changeCurrentIndex = (side) => {
    if (side === "NEXT") {
      setCurrentIndex(currentIndex + 1)
    }
    else {
      setCurrentIndex(currentIndex - 1)
    }
  }
  useEffect(() => {
    checkShowCarouselArrow(cards.length);
    window.addEventListener('resize', handleResize)
  },[]);

  const handleResize =() =>{
    setCurrentIndex(parseInt((window.innerWidth - 250) / 197, 10))
    checkShowCarouselArrow(cards.length);
  }
  return (
    <React.Fragment>
      <h4 className={'font-weight-bold mt-4'}>Insurance Products</h4>
      <Row className="mt-2 product-div">
        <Col>
          {showCarouselArrow ?
            <div className="row">
              <div className="overflow-hidden"><Carousel items={cards} numItems={cards.length} showArrow={showCarouselArrow} noOfCardDispalyed={noOfCardDispalyed()} changeCurrentIndex={changeCurrentIndex} currentIndex={currentIndex} />  </div>
            </div> :
            <Row>
              {cards}
            </Row>}
        </Col>
      </Row>
    </React.Fragment>

  )
}


// WEBPACK FOOTER //
// ./src/components/Home/Products.js